import React, { useContext, useEffect, useState } from 'react';
import "./BudgetHead.css";
import Application from '../../../StateContext/Application.js';

const BudgetHeadCreation = () => {
  const operation = useContext(Application);
  const { HeadCreation } = operation;

  // const [projectId, setProjectId] = useState([]);
  const [loading, setloading] = useState(false)

  const [data, setData] = useState({
    BudgetHeadName: "",
    ObjectCode: null,
    BudgetDetail: "",
    ExpenseType: "Revenue",
    CRC: ""
  });

  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  }

  const formData = new FormData();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setloading(true);
    try {
      for (const key in data) {
        formData.append(key, data[key]);
      }
      // let GRCopy = document.getElementById("GRCopy").files;
      // formData.append("GRCopy", GRCopy[0]);

      console.log("Data of this form ", data);
      let result = await HeadCreation(formData);
      console.log(result);
      if (result.message) {
        alert(result.message);
        window.location.reload();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setloading(false);
    }
  };




  // const FetchHeadData = async () => {
  //   try {
  //     let res = await GetProjectInfo('null', "all");
  //     setProjectId(res);
  //   }
  //   catch (err) {
  //     console.log(err);
  //   }
  // };


  // useEffect(() => {
  //   FetchHeadData();
  // }, []);



  // const HeadIDFetchOperation = async (ID) => {
  //   try {
  //     console.log(ID);

  //     let res1 = await GetProjectInfo(ID, "id");
  //     console.log("Project ID ingo :: ", res1);

  //     let projectData = res1[0];

  //     setData((prev) => ({
  //       ...prev,
  //       ProjectName: projectData.ProjectName,
  //       ProjectID: projectData.ProjectId,
  //       ProjectCost: projectData.ProjectCost,
  //       piu: projectData.PIU
  //     }))

  //   }
  //   catch (err) {
  //     console.log(err);
  //   }
  // }




  return (
    <>
      {loading && (
        <div
          style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
            display: 'flex', justifyContent: 'center', alignItems: 'center'
          }}>
          <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
          <style>
            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
          </style>
        </div>
      )}

      <div className="col-12 ">
        <h3 className='text-center fw-bold my-4'>Budget Head Creation</h3>
        <div className="col-12 m-auto my-5 budgetContainer">
          <div className="m-auto budgetElement">
            <form action="">
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label >Budget Head Name</label>
                  </div>
                  <div className="col-7">
                    <input type="text"
                      placeholder='Enter Bugdet Head Name'
                      className='form-control py-2'
                      name='BudgetHeadName'
                      value={data.BudgetHeadName}
                      onChange={HandleChangeData} />
                  </div>
                </div>
              </div>

              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>Object Code </label>
                  </div>
                  <div className="col-7">
                    <input type="number"
                      placeholder='Enter Object Code'
                      className='form-control py-2'
                      name='ObjectCode'
                      value={data.ObjectCode}
                      onChange={HandleChangeData} />
                  </div>
                </div>
              </div> */}

              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>Budget Head Type</label>
                  </div>
                  <div className="col-7">
                    <select name="BudgetHeadType" value={data.BudgetHeadType} id="" className='py-2' onChange={HandleChangeData}>
                      <option>Choose Budget Head Type</option>
                      <option value="RH Grant">RH Grant</option>
                      <option value="RH">RH </option>
                      <option value="RH1">RH1</option>
                    </select>
                  </div>
                </div>
              </div> */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label >Budget Head Details</label>
                  </div>
                  <div className="col-7">
                    <textarea type="text" placeholder='Enter Bugdet Head Details' name='BudgetDetail' value={data.BudgetDetail} onChange={HandleChangeData} ></textarea>
                  </div>
                </div>
              </div>
              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label  >Budget Head Sanction Amount</label>
                  </div>
                  <div className="col-7">
                    <input type="number" placeholder='Enter Budget Head Sanction Amount' className='form-control py-2' name='BudgetSanctionAmount' value={data.BudgetSanctionAmount} onChange={HandleChangeData} />
                  </div>
                </div>
              </div> */}


              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>Expense Type</label>
                  </div>
                  <div className="col-7">
                    <select name="ExpenseType" value={data.ExpenseType} className='py-2' onChange={HandleChangeData}>
                      < option value="Revenue">Revenue</option>
                      < option value="Capital">Capital</option>
                    </select>
                  </div>
                </div>
              </div> */}
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label  >CRC</label>
                  </div>
                  <div className="col-7">
                    <input type="text" placeholder='Enter CRC' className='form-control py-2' name='CRC' value={data.CRC} onChange={HandleChangeData} />
                  </div>
                </div>
              </div>

              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className='my-auto' >Project Name</label>
                  </div>
                  <div className="col-7">
                    <select name="ProjectID" value={data.ProjectID} id="" className='py-2' onChange={(e) => { HandleChangeData(e); HeadIDFetchOperation(e.target.value, "ProjectId") }}>
                      < option value="null">Choose Project</option>
                      {
                        projectId &&
                        projectId.map((val, index) => {
                          return (
                            <option
                              key={index}
                              value={val.ProjectId}
                            >
                              {val.ProjectName}
                            </option>
                          )
                        })
                      }
                    </select>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5 my-auto ">
                    <label className='my-auto'>Project Cost</label>
                  </div>
                  <div className="col-7">
                    <p className='py-2 px-2'>{data.ProjectCost ? data.ProjectCost : "--"}</p>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label >PIU</label>
                  </div>
                  <div className="col-7 my-auto">
                    <p className='py-2 px-2 my-auto'>{data.piu ? data.piu : "--"}</p>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label  >GR Date</label>
                  </div>
                  <div className="col-7">
                    <input type="datetime-local" placeholder='Enter Project Name' className='form-control py-2' value={data.GRDate} name='GRDate' onChange={HandleChangeData} />
                  </div>
                </div>
              </div> */}
              {/* <div className="col-12 elements">
                <div className="row">
                  <div className="col-5  ">
                    <label>GR Copy</label>
                  </div>
                  <div className="col-7">
                    <input type="file" className='form-control py-2' id='GRCopy' />
                  </div>
                </div>
              </div> */}
              <div className="col-12 ms-auto my-4">
                <div className="row">
                  <div className="col-5">
                  </div>
                  <div className="col-7">
                    <div className="col-12">
                      <button className='px-4 py-1 btn btn-primary' onClick={handleSubmit}> Save</button>
                      <button className='px-4 py-1 btn btn-danger mx-4'> Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default BudgetHeadCreation
